export const REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS = {
  NEW_REQUEST: 4,
  BOT_REQUEST: 7,
  BOT_REQUEST_PENDING_RECEIPT: 8,
  EDIT_REQUEST: 6,
  EDIT_CORRECTION: 36,
  REJECT_REQUEST: 5,
  DOWNLOAD_RECEIPT: 10,
  CORRECT_REQUEST: 73,
  SPLIT_REQUEST: 74,
  VIEW_DETAILS: 75,
  PREVALIDATED_PROCESSED: 76,
  REVERSE_REQUEST: 77,
  PROCESSED: 78,
  PAYOUT: 82,
  FAST_VIEW: 128,
  DOWNLOAD_EXCEL: 129,
  VIEW_TOTALS: 192,
  VIEW_STATUS_PENDING: 193,
  VIEW_STATUS_BOT_REQUEST: 194,
  VIEW_STATUS_PREVALIDATED_PROCESSED: 195,
  VIEW_STATUS_REJECTED: 196,
  VIEW_STATUS_BOT_PENDING_RECEIPT: 197,
  VIEW_STATUS_PROCESSED: 198,
  VIEW_STATUS_BOT_PROBLEM: 199,
  VIEW_STATUS_VALIDATED_PROCESSED: 200,
  VIEW_STATUS_CORRECTION: 201,
  VIEW_STATUS_REVERSED: 202,
  VIEW_STATUS_DIVIDED: 203,
  VIEW_STATUS_BOT_REVERSED: 204,
  VIEW_REPEATED_VOUCHERS: 244,
  VIEW_STATUS_EN_REVISION: 255,
  ATC_REVIEW_ACTION: 256,
  VIEW_DIRECT_LOAD_WITHDRAW: 257,
  SEND_WITHDRAWAL_TO_BOT: 266,
};

export const REQUEST_WITHDRAWAL_PERMISSIONS = {
  GET_FINANCIAL_DATA: 139,
  CW_TEMP_LOCK: 236,
  OVERRIDE_WITHDRAWAL_RECEIPT: 237,
  ATC_CONCURRENT_LOCK: 260,
  PROCESSED_QUEUE: 261,
};

export const FINANCIAL_BUTTON_PERMISSIONS = {
  CREATE_MOVEMENT: 12,
  GET_MOVEMENTS: 13,
  GET_MOVEMENT: 14,
  FLASH_MOVEMENT: 120,
  APROVE_REJECT: 127,
  DOWNLOAD_EXCEL: 162,
  DOWNLOAD_PDF: 163,
  // === NUEVOS PERMISOS ===
  CREATE_INVOICE: 182,
  CREATE_EXPENSE: 183,
  APPROVE_MOVEMENT: 184,
  REJECT_MOVEMENT: 185,
  FORK_MOVEMENT: 186,
  UPLOAD_DOCUMENT: 187,
  VIEW_MOVEMENT_INFO: 188,
  BATCH_APPROVE: 189,
  BATCH_REJECT: 190,
  EDIT_MOVEMENT: 191,
};

export const BANKING_BUTTON_PERMISSIONS = {
  CREATE_BANKING_ACCOUNT: 131,
  VIEW_BANKING_ACCOUNT: 132,
  BLOCK_BANKING_ACCOUNT: 133,
  EDIT_BANKING_ACCOUNT: 134,
};

export const REQUEST_BONUS_BUTTON_PERMISSIONS = {
  NEW_BONUS_BALANCE: 27,
  NEW_BONUS_CODE: 29,
  VERIFY_BONUS_CODE: 30,
  SEND_WS_BONUS_CODE: 31,
  COPY_BONUS_CODE: 32,
  DELETE_BONUS_BALANCE: 71,
  DELETE_BONUS_CODE: 72,
  EXCEL_BONUS_BALANCE: 113,
  EXCEL_BONUS_CODE: 114,
  OLD_BUTTON_CREATE_BONUS: 238
};

// STATUS
export const REQUEST_STATUS = {
  PENDING: 0,
  BOT_REQUEST: 1,
  PREVALIDATED_PROCESSED: 2,
  REJECTED: 3,
  BOT_PENDING_RECEIPT: 4,
  PROCESSED: 5,
  BOT_PROBLEM: 6,
  VALIDATED_PROCESSED: 7,
  CORRECTION: 8,
  NOT_ENTERED: 9,
  REVERSED: 10,
  DIVIDED: 11,
  REJECTED_COMMENT: 12,
  BOT_REVERSED: 13,
  EN_REVISION: 14,
};

export const STATE_PERMISSION_MAP: Record<number, number> = {
  [REQUEST_STATUS.PENDING]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_PENDING,
  [REQUEST_STATUS.BOT_REQUEST]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_BOT_REQUEST,
  [REQUEST_STATUS.PREVALIDATED_PROCESSED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_PREVALIDATED_PROCESSED,
  [REQUEST_STATUS.REJECTED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_REJECTED,
  [REQUEST_STATUS.BOT_PENDING_RECEIPT]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_BOT_PENDING_RECEIPT,
  [REQUEST_STATUS.PROCESSED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_PROCESSED,
  [REQUEST_STATUS.BOT_PROBLEM]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_BOT_PROBLEM,
  [REQUEST_STATUS.VALIDATED_PROCESSED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_VALIDATED_PROCESSED,
  [REQUEST_STATUS.CORRECTION]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_CORRECTION,
  [REQUEST_STATUS.REVERSED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_REVERSED,
  [REQUEST_STATUS.DIVIDED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_DIVIDED,
  [REQUEST_STATUS.BOT_REVERSED]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_BOT_REVERSED,
  [REQUEST_STATUS.EN_REVISION]: REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.VIEW_STATUS_EN_REVISION,
};

//TYPE TRANSACTIONS
export const TYPE_TRANSACTIONS_PERMISSIONS = {
  RISKY_WITHDRAWAL_TICKET: 85,
  DEPOSIT_CREDIT: 86,
  WITHDRAWAL_CREDIT: 87,
  BONUS_BALANCE_CHARGE: 176,
};

// EXCELL BUTTONS
export const EXCELL_BUTTONS = {
  EXCEL_AGENTS: 88,
  EXCEL_HOLDERS: 89,
  EXCEL_ADMIN: 90,
  EXCEL_PLAYERS: 91,
  EXCEL_BANKING_ACCOUNT: 135,
};

export const LOADS_WITHDRAWAL_BUTTON_PERMISSIONS = {
  ACCTIONS: 95,
  BUTTON_INSERT_MASIVE_DATA: 240,
};

export const PAYMENTS_BUTTON_PERMISSIONS = {
  CANCELATE_PAYMENTS: 96,
  MORE_ACCTIONS: 97,
  EDIT_SP: 117,
  VERIFY_SP: 121,
  VIEW_REPEATED_VOUCHERS: 242,
  VIEW_ACCOUNTING_ACCOUNTS: 268,
};

// Per-module permissions to see sensitive personal data unmasked.
export const SENSITIVE_DATA_PERMISSIONS = {
  // Whole Users module: administratives, agents, holders, players and agency applications.
  VIEW_SENSITIVE_DATA_USERS: 270,
  VIEW_SENSITIVE_DATA_CW_REQUEST: 271,
  VIEW_SENSITIVE_DATA_SP_LIST: 272,
  VIEW_SENSITIVE_DATA_BANK_BOT: 273,
  VIEW_SENSITIVE_DATA_CW_LIST: 274,
  VIEW_SENSITIVE_DATA_FEEDBACK: 276,
  VIEW_SENSITIVE_DATA_FINANCIAL: 277,
  VIEW_SENSITIVE_DATA_PAGE_BALANCE: 278,
  // Holder bank accounts and bank account groups (Accounting > Banking).
  VIEW_SENSITIVE_DATA_BANKING: 279,
  VIEW_SENSITIVE_DATA_BONUS_CODE: 280,
};

export const DEPOSIT_PAYMENT_PERMISSIONS = {
  REQUEST: 211,
  APPROVAL: 212,
  ACTIONS: 213,
  PROCESS_REVIEWED_RECORDS: 239,
  VIEW_REPEATED_VOUCHERS: 243,
};

// Must match VOUCHER_CHANGE_PERMISSIONS in the backend utils/constants.js.
export const VOUCHER_CHANGE_PERMISSIONS = {
  REQUEST: 281,
  VALIDATE: 282,
};

export const USER_LIST_PERMISSIONS = {
  // Agentes (Agents)
  VIEW_AGENT_INFO_ICON: 20,
  CREATE_NEW_AGENTS: 21,
  EDIT_AGENT: 22,
  BLOCK_AGENTS: 23,
  CHANGE_AGENT_PASSWORD: 24,
  CHANGE_AGENT_AFILIATION: 140,
  CHANGE_AGENT_AMOUNT_MAXIMUM_CHARGE: 178,
  EDIT_AGENT_ID: 206,
  EDIT_USERNAME_AGENT: 207,
  EDIT_COMISSION_PLAN: 208,
  EDIT_TYPE_COMMISSION_PLAN: 209,
  EDIT_IMAGE_AGENT: 210,
  EDIT_COUNTRY_AGENT: 214,
  EDIT_PROVINCE_AGENT: 215,
  EDIT_CITY_AGENT: 216,
  EDIT_ADDRESS_AGENT: 217,
  EDIT_MAIN_ACTIVITY_AGENT: 218,
  EDIT_HAS_RUC_AGENT: 219,
  EDIT_ENVIRONMENT_AGENT: 220,
  EDIT_CODE_PHONE_AGENT: 221,
  EDIT_CELLPHONE_AGENT: 222,
  EDIT_EMAIL_AGENT: 223,
  EDIT_UNLIMITED_BONUS_AGENT: 224,
  EDIT_BANK_GROUP_AGENT: 225,
  EDIT_OBSERVATION_AGENT: 226,
  EDIT_REQUIREMENTS_AGENT: 227,
  EDIT_AGENT_ACTIVITY_AGENT: 228,
  EDIT_CLOSURE_TYPE_AGENT: 229,
  EDIT_PROVIDER_1_AGENT: 230,
  EDIT_GIVE_PERCENTAGE_1_AGENT: 231,
  EDIT_PROVIDER_2_AGENT: 232,
  EDIT_GIVE_PERCENTAGE_2_AGENT: 233,
  EDIT_PROVIDER_3_AGENT: 234,
  EDIT_GIVE_PERCENTAGE_3_AGENT: 235,
  VIEW_BONUS_AGENT:258,
  VIEW_AGENT_AUDIT_HISTORY: 265,

  // Titulares (Holders)
  CREATE_NEW_HOLDER: 68,
  BLOCK_HOLDER: 69,
  EDIT_HOLDER: 98,
  VIEW_HOLDER_INFO_ICON: 99,

  // Administrativos (Administrative)
  CREATE_NEW_ADMINISTRATIVE: 101,
  EDIT_ADMINISTRATIVE: 102,
  BLOCK_ADMINISTRATIVE: 103,
  CHANGE_ADMINISTRATIVE_PASSWORD: 104,
  VIEW_ADMINISTRATIVE_INFO_ICON: 100,
  VIEW_ADMINISTRATIVE_AUDIT_HISTORY: 264,

  // Jugadores (Players)
  CREATE_NEW_PLAYERS: 107,
  EDIT_PLAYERS: 108,
  VIEW_PLAYER_INFO_ICON: 105,
  COPY_PLAYER_PASSWORD: 106,
  CONTACT_PLAYER: 141,
  CONSULT_AMOUNTS: 142,
  AGENT_COLUMNS: 143,
  BONUS_COLUMNS: 165,

  // NOTIFICATIONS
  VIEW_NOTIFICATIONS: 148,
  VIEW_FINANCIAL_NOTIFICATIONS: 259,
  ATC_CONCURRENT_LOCK: 260,
};

//RRHH Permisos
export const RRHH_LIST_PERMISSIONS = {
  CREATE_NEW_PERMMISSION_RRHH: 122,
  EDIT_EDIT_PERMISSION_RRHH: 123,
  CHANGE_STATE_PERMISSION_RRHH: 124,
  VIEW_PERMISSION_RRHH: 125,
  DOWNLOAD_EXCEL_PERMISSION_RRHH: 126,
  VIEW_ALL_PERMISSIONS_DATA: 205,
};

// REPORTS
export const REPORT_PERMISSIONS = {
  SEND_CLOSURE: 1,
  CONSULT_CLOSURE: 2,
};

export const RRHH_BUTTON_PERMISSIONS = {
  EDIT: 118,
  CREATE: 119,
  SEND: 130,
};

export const ACCOUNTING_BUTTON_PERMISSIONS = {
  CREATE_DIARY_ACCOUNTING_ACCOUNT: 136,
  EDIT_DIARY_ACCOUNTING_ACCOUNT: 137,
  DELETE_DIARY_ACCOUNTING_ACCOUNT: 138,
};

export const AFFILIATE_BUTTONS_PERMISSIONS = {
  ADD_NEW_PROMOTIONAL_MATERIAL: 149,
  EDIT_PROMOTIONAL_MATERIAL: 166,
  DELETE_PROMOTIONAL_MATERIAL: 167,
  DOWNLOAD_PROMOTIONAL_MATERIAL: 168,
  CREATE_LOCATION: 172,
};

export const DASHBOARD_PERMISSIONS = {
  BANK_ACCOUNTS: 153,
  REGISTERED_PLAYERS: 154,
  SUMMARY_OF_FINANCIAL_MOVEMENT: 155,
  EXPENSES_BY_ACCOUNT: 156,
  LATEST_EXPENSE_MOVEMENTS: 157,
  PROFIT_PER_PLAYER: 158,
  PROFIT_PER_AGENT: 159,
  INCOME_AND_EXPENSES: 160,
  TOTAL_PAGE_BALANCE: 161,
};

export const CLOSURE_MANAGEMENT = {
  BULK_UPLOAD_BUTTON: 179,
  BUTTON_DOWNLOAD: 180,
};

export const PAGE_BALANCE_BUTTONS_PERMISSIONS = {
  EDIT_BALANCES: 252,
  INSERT_BALANCES_MONTHLY: 253,
  EXPORT_BALANCES: 254,
};

export const SUPPORT_MODE_PERMISSIONS = {
  TOGGLE_SUPPORT_MODE: 267,
};
